/**
 * Mirror of the server-side helper in `lead.card-extras.ts`. Title-cases
 * a niche model name for display on the lead card / show-hide menu.
 *
 * We can't rely on `ModuleConnecter.connectionLabel` for the menu because
 * tenants commonly leave it as a single shared group name (e.g.
 * "Academic") across every connector — every checkbox would then read
 * the same. The `nicheModelName` is unique per niche and matches what
 * the Add-Requirement / niche-picker UIs display.
 *
 *   course → Course
 *   videoServiceVarients → Video Service Varients
 *   qualificationLevel → Qualification Level
 */
export function humanizeNicheModelName(name: string): string {
  if (!name) return "";
  const spaced = name.replace(/([A-Z])/g, " $1");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
